export const MODAL_ID = "UI_LOGIN_ALERT_ID";
